import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { confirm } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const ExamAttachmentsList = observer(class ExamAttachmentsList extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.deleteFile = this.deleteFile.bind(this);
    this.getExamFile = this.getExamFile.bind(this);
  }

  extension(filename) {
    const ext = filename.substr(filename.lastIndexOf('.') + 1);

    switch (ext) {
      case 'bmp':
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <icons.icon_image />;

      case 'pdf':
        return <icons.icon_pdf />;

      case 'doc':
      case 'docx':
      case 'txt':
      case 'rtf':
        return <icons.icon_text />;

      case 'xls':
      case 'xlsx':
      case 'csv':
        return <icons.icon_spreadsheet />;

      case 'wma':
      case 'mpg':
      case 'avi':
      case 'flv':
        return <icons.icon_video />;

      case 'mp3':
      case 'ogg':
      case 'wav':
      case 'midi':
        return <icons.icon_audio />;

      case 'zip':
      case 'gz':
      case 'iso':
        return <icons.icon_zip />;

      default:
        return <icons.icon_file />;
    }
  }

  deleteFile(file, index, type) {
    const { exam, translation } = this.props;
    const { ExamStore } = this.props.store;
    let data = null;

    const msg = {
      heading: `${translation.delete_confirm.heading} ${file}?`,
      body: translation.delete_confirm.body,
      button: translation.delete_confirm.button
    }

    if(type === 'written') {
      msg.body = translation.delete_confirm.body_written;

      data = {
        examFiles: [file]
      };
    } else {
      data = {
        attachments: [file]
      };
    }

    if(type !== 'written') {
      confirm(msg, () => {
        ExamStore.deleteExamAttachments(
          exam.sid,
          exam.configuration.sid,
          data,
          () => this.removeFile(index, type)
        )
      });
    } else {
      confirm(msg, () => {
        ExamStore.deleteExamAttachments(
          exam.sid,
          exam.configuration.sid,
          data,
          () => this.removeFile(index, type)
        )
      });
    }
  }

  removeFile(index, type) {
    if(type !== 'written') {
      this.props.exam.configuration.attachments.splice(index, 1);
    } else {
      this.props.exam.configuration.examFiles.splice(index, 1);
    }
  }

  getExamFile(fileName) {
    const { ExamStore } = this.props.store;
    const { exam, installSid } = this.props;
    let backgroundLoad = false;

    if(this.props.overview) {
      backgroundLoad = true;
    }

    ExamStore.getExamFile(exam.configuration.sid, fileName, installSid, backgroundLoad);
  }

  renderResults(panel) {
    const { customConfiguration, exam, translation } = this.props;

    let configuration = exam.configuration;

    // If this is a custom configuration, use that data
    if(customConfiguration) {
      configuration = customConfiguration;
    }

    // Determine whether to use attachments or examFiles
    let files = null;
    let type = null;

    if(exam.type.toLowerCase() !== 'written') {
      files = configuration.attachments;
      type = 'online';
    } else {
      files = configuration.examFiles;
      type = 'written';
    }

    if(
      files &&
      files.length > 0
    ) {
      return (
        <ul className={`files ${panel ? 'panel__files' : ''}`}>
          {files.map(
            (key, i) =>
            <li key={i}>
              {type === 'online' &&
                <a
                  className="files__title"
                  href={key.attachmentUrl}
                  target="_blank"
                >
                  {this.extension(key.attachmentAwsTitle)}
                  {key.attachmentAwsTitle}
                </a>
              }

              {type === 'written' &&
                <button
                  className="files__title btn--link"
                  href="#"
                  onClick={() => this.getExamFile(key.attachmentAwsTitle)}
                >
                  {this.extension(key.attachmentAwsTitle)}
                  {key.attachmentAwsTitle}
                </button>
              }

              {!this.props.sessionManager && !this.props.hideDelete &&
                <button
                  className="btn--remove"
                  type="button"
                  onClick={() => this.deleteFile(key.attachmentAwsTitle, i, type)}
                >
                  <icons.iconMinus />
                  <span className="meta">{translation.remove} {key.attachmentAwsTitle}</span>
                </button>
              }
            </li>
          )}
        </ul>
      )
    } else if(panel) {
      return (
        <span className="no-results">
          {exam.type.toLowerCase() !== 'written' && translation.no_results}
          {exam.type.toLowerCase() === 'written' && translation.no_results_written}
        </span>
      )
    } else {
      return (
        <span>
          {exam.type.toLowerCase() !== 'written' && translation.no_results}
          {exam.type.toLowerCase() === 'written' && translation.no_results_written}
        </span>
      )
    }
  }

  render() {
    const { exam, overview, translation } = this.props;

    if(!overview) {
      return (
        <section className="panel__section">
          {!this.props.sessionManager && !this.props.hideTitle &&
            <h2 className="panel__heading">
              {exam.type.toLowerCase() !== 'written' && translation.heading}
              {exam.type.toLowerCase() === 'written' && translation.heading_written}
            </h2>
          }

          {this.props.sessionManager && !this.props.hideTitle &&
            <h4 className="data-heading">
              {exam.type.toLowerCase() !== 'written' && translation.heading}
              {exam.type.toLowerCase() === 'written' && translation.heading_written}
            </h4>
          }

          {this.renderResults(true)}
        </section>
      )
    } else {
      return (
        <div>
          {this.renderResults(false)}
        </div>
      )
    }
  }
})

export default translate('ExamAttachmentsList')(ExamAttachmentsList);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ExamAttachmentsList.js